<template>
  <div>
    <v-toolbar
      class="mb-4"
      flat
    >
      <v-btn-toggle
        v-model="pass"
        class="mr-2"
        color="success"
        dense
        group
      >
        <v-btn :value="true">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-divider class="mx-2" vertical />

      <v-flex shrink>
        <v-select
          v-model="orderKey"
          class="ml-4"
          :items="orderKeys"
          item-text="text"
          item-value="key"
          hide-details
          prepend-inner-icon="mdi-sort"
          :disabled="!pass || !enableSort"
          return-object
        />
      </v-flex>

      <v-btn-toggle
        v-model="orderDirection"
        color="primary"
        mandatory
        dense
        group
      >
        <v-btn value="asc">
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
        <v-btn value="desc">
          <v-icon>mdi-arrow-down</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-spacer />

      <v-btn
        icon
        x-large
        :disabled="page == 0"
        @click="page -= 1"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      {{ page+1 }}
      <v-btn
        icon
        x-large
        :disabled="results.length < itemsPerPage * (page + 1)"
        @click="page += 1; maxPage = Math.max(maxPage, page)"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-toolbar>

    <v-row
      v-if="currentItems.length > 0"
    >
      <v-col
        v-for="item in currentItems"
        :key="item.id"
        cols="12"
        sm="12"
        md="6"
        lg="4"
      >
        <ResultCard :code="item" :highlight="orderKey.key" />
      </v-col>
    </v-row>
    <div v-else>
      データがありません
    </div>

  </div>
</template>

<script>
import ResultCard from '@/components/ResultCard.vue'

export default {
  components: {
    ResultCard,
  },
  props: [
    'query',
    'enableSort',
  ],
  data: () => ({
    results: [],
    itemsPerPage: 6,
    page: 0,
    maxPage: 0,
    pass: false,
    orderKey: { key: "submittedAt" },
    orderDirection: "desc",
    lastQuery: {},
    orderKeys: [
      { key: "submittedAt",     text: "提出日",         dir: "desc" },
      { key: "sim_time",        text: "SIMタイム",      dir: "asc" },
      { key: "sim_cycle",       text: "SIMサイクル",    dir: "asc" },
      { key: "clock_frequency", text: "クロック周波数", dir: "desc" },
      { key: "clock_period",    text: "クロック周期",   dir: "asc" },
      { key: "ff",              text: "FF",             dir: "asc" },
      { key: "lut",             text: "LUT",            dir: "asc" },
      { key: "dsp",             text: "DSP",            dir: "asc" },
      { key: "bram",            text: "BRAM",           dir: "asc" },
      { key: "uram",            text: "URAM",           dir: "asc" },
    ],
  }),
  computed: {
    currentItems: function() {
      return this.results.slice(this.itemsPerPage * this.page, this.itemsPerPage * (this.page + 1))
    },
  },
  methods: {
    bind: function () {
      if (this.query &&
          (this.maxPage > this.lastQuery.maxPage ||
           this.pass != this.lastQuery.pass ||
           this.orderKey.key != this.lastQuery.orderKey ||
           this.orderDirection != this.lastQuery.orderDirection))
      {
        this.lastQuery.maxPage = this.maxPage
        this.lastQuery.pass = this.pass
        this.lastQuery.orderKey = this.orderKey.key
        this.lastQuery.orderDirection = this.orderDirection

        let query = this.query
        if (this.pass) {
          query = query.where("pass", "==", true)
        }
        query = query.orderBy(this.orderKey.key, this.orderDirection)
        this.$bind("results", query.limit(this.itemsPerPage * (this.maxPage + 1)))
      }
    },
  },
  watch: {
    maxPage: function () { this.bind() },
    query:          function () { this.page = 0; this.bind() },
    orderDirection: function () { this.page = 0; this.bind() },
    orderKey: function () {
      this.page = 0
      this.orderDirection = this.orderKey.dir
      this.bind()
    },
    pass: function () {
      this.page = 0
      if (!this.pass) {
        this.orderKey = this.orderKeys[0]
        this.orderDirection = "desc"
      }
      this.bind()
    },
  },
  created() {
    this.bind()
  },
};
</script>

